export default __webpack_public_path__ + "static/media/Caixa.8ef348f3.svg";